export const RANDOM = 'random';
export const BOX = 'box';
